/**
 * Surgical specialties covered by the built-in procedure catalog.
 * `Profile.especialidad` stays free text (wire contract); matching against
 * these names is case/accent-insensitive (see `getSpecialtyByName`).
 * `nameEs` is the Spanish display name (UI language es); `name` is English.
 */
import type { CatalogSpecialty } from './types';

export const SPECIALTIES: CatalogSpecialty[] = [
  { id: 'general-surgery', name: 'General surgery', nameEs: 'Cirugía general' },
  { id: 'orthopedic-surgery', name: 'Orthopedic & trauma surgery', nameEs: 'Cirugía ortopédica y traumatología' },
  { id: 'gynecology', name: 'Gynecology & obstetrics', nameEs: 'Ginecología y obstetricia' },
  { id: 'urology', name: 'Urology', nameEs: 'Urología' },
  { id: 'cardiovascular-surgery', name: 'Cardiovascular surgery', nameEs: 'Cirugía cardiovascular' },
  { id: 'neurosurgery', name: 'Neurosurgery', nameEs: 'Neurocirugía' },
  { id: 'ent-surgery', name: 'ENT surgery', nameEs: 'Otorrinolaringología' },
  { id: 'ophthalmology', name: 'Ophthalmology', nameEs: 'Oftalmología' },
  { id: 'plastic-surgery', name: 'Plastic & reconstructive surgery', nameEs: 'Cirugía plástica y reparadora' },
  { id: 'thoracic-surgery', name: 'Thoracic surgery', nameEs: 'Cirugía torácica' },
  { id: 'pediatric-surgery', name: 'Pediatric surgery', nameEs: 'Cirugía pediátrica' },
  { id: 'maxillofacial-surgery', name: 'Maxillofacial surgery', nameEs: 'Cirugía maxilofacial' },
];
